/**
 * @param {?} value
 * @param {?} index
 * @return {?}
 */
export function Ly_Prev(value, index) {
    var /** @type {?} */ nxt = value;
    var /** @type {?} */ i = index;
    var /** @type {?} */ length = nxt.length;
    var /** @type {?} */ _index;
    if ((i - 1) <= 0 || (i - 1) >= length - 1) {
        nxt = (nxt[(nxt.length - 1)]);
        _index = (nxt.length - 1);
    }
    else if (i === 0) {
        nxt = (nxt[(0)]);
        _index = (0);
    }
    else {
        nxt = (nxt[(i - 1)]);
        _index = (i - 1);
    }
    return {
        index: _index,
        prev: nxt,
    };
}



//////////////////
// WEBPACK FOOTER
// ./src/app/alyle-ui-profile/core/array/prev.js
// module id = 1349
// module chunks = 31